import React from 'react';
import axios from 'axios';
import { withApollo, graphql } from 'react-apollo';
import { CLIENT_KEY, ROLES } from '../../../../graphql/query';
import { irpcApiBaseUrl } from '../../../../config';

const withUsersTable = Component => {
  class WithUsersTable extends React.Component {
    state = {
      loading: true,
      name: '',
      pageIndex: 1,
      hasNextPage: true,
      data: undefined,
      onlyAdmin: false,
    };

    async componentDidMount() {
      await this.loadUserData();
    }

    async loadUserData() {
      const { client } = this.props;
      const { clientKey } = (await client.query({
        query: CLIENT_KEY,
      })).data;
      const isAdminCriteria = this.state.onlyAdmin
        ? { usernames: [...(this.props.data.roles || []).map(user => user.username)] }
        : {};

      const re = await axios.post(
        `${irpcApiBaseUrl}/api/profile/list`,
        {
          criteria: {
            name: this.state.name,
            ...isAdminCriteria,
          },
          rowsPerPage: 100,
          pageIndex: this.state.pageIndex,
        },
        {
          headers: {
            'x-client-key': clientKey,
          },
        }
      );

      if (this.state.pageIndex === 1) {
        this.setState({
          loading: false,
          data: re.data.data.list,
        });
      } else {
        this.setState({
          loading: false,
          data: [...this.state.data, ...re.data.data.list],
          hasNextPage: re.data.data.list.length > 0,
        });
      }
    }

    searchByName = async name => {
      this.setState({
        name,
        pageIndex: 1,
        hasNextPage: true,
      });

      await this.loadUserData();
    };

    loadNextPage = async () => {
      this.setState(state => {
        return { pageIndex: state.pageIndex + 1 };
      });

      await this.loadUserData();
    };

    toggleOnlyAdmin = async () => {
      this.setState(prevState => ({
        onlyAdmin: !prevState.onlyAdmin,
        pageIndex: 1,
        hasNextPage: true,
      }));

      await this.loadUserData();
    };

    render() {
      const { loading, roles } = this.props.data;
      if (loading) {
        return null;
      }
      return (
        <Component
          searchByName={this.searchByName}
          loadNextPage={this.loadNextPage}
          toggleOnlyAdmin={this.toggleOnlyAdmin}
          {...this.state}
          admins={roles.reduce((obj, role) => {
            return { ...obj, [role.username]: role.role };
          }, {})}
        />
      );
    }
  }

  return withApollo(graphql(ROLES)(WithUsersTable));
};

export default withUsersTable;



// WEBPACK FOOTER //
// ./src/main/content/project/users/withUsersTable.js